module.exports = __webpack_public_path__ + "static/gallery12-80b7fcec94e406903212994b69a275a6.jpg";